import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap, map } from 'rxjs/operators';
import { EnvService } from 'src/app/services/env.service';
import { ToastController } from '@ionic/angular';
import { NavController } from '@ionic/angular';

import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { Mdlprovincia } from 'src/app/xbase/models/mdlbase';
import { OpenlinkService } from 'src/app/xbase/services/openlink.service';
import { AbstractControl } from '@angular/forms';
import { temporaryAllocator } from '@angular/compiler/src/render3/view/util';
import { Location } from "@angular/common";
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  mdlprovincia: Mdlprovincia[];
  DatiAccesso: any;

  constructor(
    private http: HttpClient,
    private navCtrl: NavController,
    private env: EnvService,
    private toastController: ToastController,
    private alertService: AlertService,
    private authService: AuthService,
    private openlinkService: OpenlinkService,
    private location: Location,
  ) {
  }
   
  caricaTabella(NomeTabella:String){
      return this.authService.getStorageObject('TAB_' + NomeTabella).then(
      data => {
      },
      error => {}
    );
  }
  

  //Legge la Tabella indicata e la conserva nello storage
  api_tabellaRead(NomeTabella: String) {
    this.DatiAccesso=this.authService.resumeDatiAccesso();
    let postData = {
      "wsPgini":this.env.API_wsPgini,
      "wsMode": NomeTabella, //Nome della tabella
      "wsTokenLogin": this.DatiAccesso["wsTokenLogin"],
    } 
    return this.http.post<any>(this.env.API_URL + this.env.API_PROC + 'api_tabelle.php', postData
    ).pipe(
      tap(jsondata => {
        this.authService.setStorageObject('TAB_'+NomeTabella, jsondata["wsRows"])
        .then(
          () => {
          },
          error => {this.alertService.presentToast('Errore:'+' ('+jsondata["wsCdrisp"]+') '+jsondata["wsDsrisp"]);}
        );
      }),
    );
  }

  api_tabellaReadDir(NomeTabella: String, FlDisattSiNo:String, ElemVuotoSiNo:String) {
    this.DatiAccesso=this.authService.resumeDatiAccesso();
    let postData = {
      "wsPgini":this.env.API_wsPgini,
      "wsMode": NomeTabella, //Nome della tabella
      "wsTokenLogin": this.DatiAccesso["wsTokenLogin"],
      "FlDisattSiNo": FlDisattSiNo,
      "ElemVuotoSiNo": ElemVuotoSiNo,
    } 
    //console.log("postDataA="+JSON.stringify(postData)+"-"+Idtpinfonews);//PIERO
    return this.http.post<any>(this.env.API_URL + this.env.API_PROC + 'api_tabelle.php', postData
    ).pipe(
      tap(jsondata => {
        //console.log("jsondata="+JSON.stringify(jsondata));//PIERO
        if(jsondata["wsCdrisp"]!="0"){this.alertService.presentToast('Errore:'+' ('+jsondata["wsCdrisp"]+') '+jsondata["wsDsrisp"]);}
        return jsondata;
       })
    )   
  }

  //Apre Google Maps
  openMapsApp(Action:any,Return:any,Indirizzo:any,Civico:any,Cap:any,Localita:any,Prov:any,Dsnazione:any,Lat:any,Long:any){
    //Action=S  Search - launch a Google Map that displays a pin for a specific place, 
    //                   or perform a general search and launch a map to display the results:
    //                   https://www.google.com/maps/search/?api=1&parameters

    //Action=D  Directions - request directions and launch Google Maps with the results:
    //                   https://www.google.com/maps/dir/?api=1&parameters

    //Action=M  Dispay a Map - launch Google Maps with no markers or directions:
    //                   https://www.google.com/maps/@?api=1&map_action=map&parameters

    //Action=V  Display a Street View panorama - launch an interactive panorama image:
    //                   https://www.google.com/maps/@?api=1&map_action=pano&parameters
    //https://developers.google.com/maps/documentation/urls/guide

    if(Civico!=''&&Indirizzo!=''){Indirizzo+=', '+Civico;}
    //https://www.google.com/maps?q=via Pietro Mascagni, 65+Ragusa+97100+RG+
    var location:String ='';
    if(Lat!=''&&Long!=''){
      location=Lat+", "+Long;
      if(Action=="M"){location='center='+location+'&zoom=10';}
      if(Action=="V"){location='viewpoint='+location+'&pitch=0&fov=80';}
    }else{
      location=Indirizzo+"+"+Localita+"+"+Cap+"+"+Prov+"+"+Dsnazione;
    }
    //console.log('location: ' + location);
    var LocHref:any='';
    if(Action=="S"){LocHref='https://www.google.com/maps/search/?api=1&query='+location;}
    if(Action=="D"){LocHref='https://www.google.com/maps/dir/?api=1&destination='+location;}
    if(Action=="M"){LocHref='https://www.google.com/maps/@?api=1&map_action=map&'+location;}
    if(Action=="V"){LocHref='https://www.google.com/maps/@?api=1&map_action=pano&'+location;}
    //console.log(LocHref);//PIERO
    var LocHrefenc=encodeURI(LocHref);
    //console.log(LocHrefenc);//PIERO
    //if(LocHrefenc!=''){window.open(LocHrefenc,'_blank');}
    //if(LocHrefenc!=''){this.openlinkService.openWithSystemBrowser(LocHrefenc);}
    if(Return="S"){
        if(location=="++++"){LocHrefenc="";}
        return LocHrefenc;
      }else{
        if(LocHrefenc!=''){this.openlinkService.openBrowser(LocHrefenc);}
    }
    //lancio a secondo la piattaforma, ma non va bene!
    //if (this.authService.DevicePlatform=='Android') {
      //window.location.href = 'geo:' + location;
    //} else {
      //window.location.href = 'maps://maps.apple.com/?q=' + location;
    //}
  }

  //Convert File size in KB, MB, GB ....===========================================================
  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
  //============================================================Convert File size in KB, MB, GB ===

  //===Conversioni date============================================================================
  DateToMask(dt:string){//da AAAAMMGG => GG/MM/AAAA
    return dt.substr(6, 2)+"/"+dt.substr(4, 2)+"/"+dt.substr(0, 4);
  }
  MaskToDate(dt:string){//da GG/MM/AAAA => AAAAMMGG
    return dt.substr(6,4)+dt.substr(3, 2)+dt.substr(0, 2);
  }

  //Tramuta una data AAAAMMGG in material matDatepicker
  dateMATDbToApp(cmp:any){
    if(cmp==null||cmp==""){let valy:Date; return valy;}
    const val = cmp.substr(4, 2)+"/"+cmp.substr(6, 2)+"/"+cmp.substr(0, 4);//nel formato MM/GG/AAAA
    const valx:Date =new Date(val);
    return valx;
  }
  //Tramuta una data material matDatepicker nel formato AAAAMMGG
  dateMATAppToDb(ev:any){
    let val=ev.target.value;
    if(val==null){
      return "";
    }else{
      var d = new Date(val);
      let dt = d.getFullYear() + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2);
      return dt;
    }
  }
  //Tramuta una data AAAAMMGG in ion-input type="date" nel formato AAAA-MM-GG
  dateDATDbToApp(cmp:any){
    if(cmp==null||cmp==""){return "";}
    const dt = cmp.substr(0, 4)+"-"+cmp.substr(4, 2)+"-"+cmp.substr(6, 2);
    return dt;
  }
  //Tramuta una data ion-input type="date" AAAA-MM-GG nel formato AAAAMMGG
  dateDATAppToDb(ev:any){
    let val=ev.target.value;
    if(val==null){
       return "";
    }else{
      const dt = val.substr(0, 4)+val.substr(5, 2)+val.substr(8, 2);
      return dt;
    }
  }
  
  //Tramuta una data AAAAMMGG in ion-datetime
  dateIONDbToApp(cmp:any){
    if(cmp==null||cmp==""){return "";}
    const dt = cmp.substr(0, 4)+"-"+cmp.substr(4, 2)+"-"+cmp.substr(6, 2);
    return dt;
  }
  //Tramuta una data ion-datetime nel formato AAAAMMGG
  dateIONAppToDb(ev:any){
    let val=ev.target.value;
    if(val==null){
       return "";
    }else{
      let dt="";
      if (typeof val === "object"){
        dt = val.year.text+val.month.text+val.day.text;//PIERO
      }else{
        dt = val.substr(0, 4)+val.substr(5, 2)+val.substr(8, 2);
      }
      return dt;
    }
  }

  //Tramuta una data AAAAMMGG in una data ion-input type="text" GG-MM-AAAA
  dateTXTDbToApp(cmp:any){
    if(cmp==null||cmp==""){return "";}
    const dt = cmp.substr(6, 2)+"-"+cmp.substr(4, 2)+"-"+cmp.substr(0, 4);
    return dt;
  }
  //Tramuta una data ion-input type="text" GG-MM-AAAA nel formato AAAAMMGG
  dateTXTAppToDb(ev:any){
    let val=ev.target.value;
    if(val==null){
       return "";
    }else{
      const dt = val.substr(6, 4)+val.substr(3, 2)+val.substr(0, 2);
      return dt;
    }
  }
  //============================================================================Conversioni date===

  //===Conversioni ORE=============================================================================
  OraToMask(ora:string){//da HHMM => HH:MM
    if(ora==null||ora==""||ora.length!=4){return "";}
    return ora.substr(0, 2)+":"+ora.substr(2, 2);
  }
  MaskToOra(ora:string){//da HH:MM => HHMM
    if(ora==null||ora.length!=5){return "";}
    return ora.substr(0,2)+ora.substr(3, 2);
  }

  //Tramuta da HHMM => HH:MM
  oraVIDDbToApp(ora:any){
    if(ora==null||ora==""||ora.length!=4){return "";}
    return ora.substr(0, 2)+":"+ora.substr(2, 2);
  }
  //Tramuta da HH:MM => HHMM
  oraVIDAppToDb(ev:any){
    let ora=ev.target.value;
    if(ora==null||ora.length!=5){return "";}
    return ora.substr(0,2)+ora.substr(3, 2);
  }
  //============================================================================Conversioni ORE===

  //===Lancio di una Email========================================================================
  clickEmail(Email:any){
    window.location.href = "mailto:"+Email;
  }
  //========================================================================Lancio di una Email===

  //===Aggiunge le barre in terza e sesta posizione in un campo DATA================================
  MaskDate(event:any) {
    let key=event.key;          //Key digitata (carattere, enter key, backspace, ecc) in Android è=Unidentified se si tratta di carattere
    let keyNum=Number(key);     //Key in formato numerico
    let val=event.target.value; //valore del campo comprendente il carattere digitato
    let valNum=Number(val);     //valore in formato numerico
    //console.log(" val="+val+" test val="+Number.isInteger(valNum)+" key="+key);
    //if(val.length==2 && Number.isInteger(valNum) && key!="Backspace"){event.target.value=val+"/";}
    if(val.length==2 && key!="Backspace"){event.target.value=val+"/";}
    if(val.length==5 && key!="Backspace"){event.target.value=val+"/";}
  }
  //================================Aggiunge le barre in terza e sesta posizione in un campo DATA===

  //===Aggiunge i due punti in terza posizione in un campo ORARIO===================================
  MaskOrario(event:any) {
    let key=event.key;          //Key digitata (carattere, enter key, backspace, ecc) in Android è=Unidentified se si tratta di carattere
    let keyNum=Number(key);     //Key in formato numerico
    let val=event.target.value; //valore del campo comprendente il carattere digitato
    let valNum=Number(val);     //valore in formato numerico
    //console.log(" val="+val+" test val="+Number.isInteger(valNum)+" key="+key);
    //if(val.length==2 && Number.isInteger(valNum) && key!="Backspace"){event.target.value=val+":";}
    if(val.length==2 && key!="Backspace"){event.target.value=val+":";}
  }
  //===================================Aggiunge i due punti in terza posizione in un campo ORARIO===

  //Confronto tra due date in digitazione
  checkDateIniFinValidator(cmpDate1: string, cmpDate2: string){
    return (controls: AbstractControl) => {
      const ctrDate1= controls.get(cmpDate1);
      const ctrDate2= controls.get(cmpDate2);
      //console.log("ctrDate1="+ctrDate1.value+" ctrDate2="+ctrDate2.value);//Valore digitato
      if (ctrDate2.hasError('wrongFinDate')) {
        delete ctrDate2.errors['wrongFinDate'];//Calcella l'eventuale errore
        ctrDate2.updateValueAndValidity();
      }
      const ctrDate1dat = new Date(ctrDate1.value);//Valore in formato UTC
      const ctrDate2dat = new Date(ctrDate2.value);//Valore in formato UTC
      //console.log("ctrDate1dat="+ctrDate1dat+" ctrDate2dat="+ctrDate2dat);
      if(ctrDate1.value==null||ctrDate2.value==null){return;}//Devono essere impostate entrambe
      if (ctrDate2dat < ctrDate1dat) {
          return ctrDate2.setErrors({ wrongFinDate: true }); // note the return statement.
      }
      //return ctrDate2.setErrors({ wrongFinDate: false }); // Non attivare
    }
  }

  //Confronto Password
  checkPasswordValidator(cmpPwd1: string, cmpPwd2: string){
    return (controls: AbstractControl) => {
      const ctrPwd1= controls.get(cmpPwd1);
      const ctrPwd2= controls.get(cmpPwd2);
      //console.log("ctrDate1="+ctrDate1.value+" ctrDate2="+ctrDate2.value);//Valore digitato
      if (ctrPwd2.hasError('wrongPasswordMatch')) {
        delete ctrPwd2.errors['wrongPasswordMatch'];//Calcella l'eventuale errore
        ctrPwd2.updateValueAndValidity();
      }
      if(ctrPwd1.value==null||ctrPwd2.value==null||ctrPwd1.value != ctrPwd2.value){
          return ctrPwd2.setErrors({ wrongPasswordMatch: true }); // note the return statement.
      }
    }
  }

  //UPDATE USER LANGUAGE
  api_UserLanguage(IdLanguage:number) {
    this.DatiAccesso=this.authService.resumeDatiAccesso();
    let postData = {
      "wsPgini":this.env.API_wsPgini,
      "wsMode": "Lang",//Update language
      "wsTokenLogin": this.DatiAccesso["wsTokenLogin"],
      "usrIdLanguage": IdLanguage,
    } 
    //console.log("postDataxx = "+JSON.stringify(postData));//PIERO
    return this.http.post<any>(this.env.API_URL + this.env.API_PROC + 'api_user.php', postData
    ).pipe(
      tap(jsondata => {
        //console.log("wsRows Da Update="+JSON.stringify(jsondata["wsRows"]));//PIERO
        if(jsondata["wsCdrisp"]!="0"){this.alertService.presentToast('Errore:'+' ('+jsondata["wsCdrisp"]+') '+jsondata["wsDsrisp"]);}
      })
    )   
  }

  api_PickDefault(tpDefault:any) {
    let postData = {
      "wsPgini":this.env.API_wsPgini,
      "wsMode": "R",//Update language
      "tpDefault": tpDefault,
    } 
    //console.log("postDataxx = "+JSON.stringify(postData));//PIERO
    return this.http.post<any>(this.env.API_URL + this.env.API_PROC + 'api_pickdefault.php', postData
    ).pipe(
      tap(jsondata => {
        //console.log("wsRows Da Update="+JSON.stringify(jsondata["wsRows"]));//PIERO
        if(jsondata["wsCdrisp"]!="0"){this.alertService.presentToast('Errore:'+' ('+jsondata["wsCdrisp"]+') '+jsondata["wsDsrisp"]);}
      })
    )   
  }
  //======================================================================================NEWS===

  DataOraDisp(){
    var dt = new Date();
    const day = ("0" + dt.getDate()).slice(-2);
    const month = ("0" + dt.getMonth()).slice(-2);
    const year = dt.getFullYear();
    const ore = dt.getHours();
    const min = dt.getMinutes();
    const sec = dt.getSeconds();
    let tempo:any= "["+day+"/"+month+"/"+year+" "+ore+":"+min+":"+sec+"] ";
    return tempo;
  }
  
  test_jsondata(jsondata:any, point:any){
    console.log(point+": "+JSON.stringify(jsondata));//PIERO
    //if(jsondata["wsCdrisp"]=="1"){
      //this.alertService.presentToast("Err: "+jsondata["wsDsrisp"]);
      //console.log(this.DataOraDisp()+point+'-Errore:'+' ('+jsondata["wsCdrisp"]+') '+jsondata["wsDsrisp"]);//PIERO
    //}
  }

  elab_Risposta_Api(data:any, registrationForm:any){
    this.env.APIwsCdrisp=data["wsCdrisp"];
    this.env.APIwsDsrisp="";
    if(data["wsCdrisp"]!="0"){if(data["wsDsrisp"]!=""){this.env.APIwsDsrisp=this.env.getTranslation(data["wsDsrisp"]);}}
    if(data["wsCdrisp"]=="2"){
      registrationForm.controls[data["wsCampoErr"]].setErrors({[data["wsNomeErr"]]: true});
    }
  }

  /*
  impostaDEFAULT_IdLanguage(mdllanguagess:any){
    console.log(mdllanguagess=": "+JSON.stringify(mdllanguagess));//PIERO
    if(mdllanguagess["lanFldefault"]=="1"){
      this.env.DEFAULT_IdLanguage=mdllanguagess["lanIdLanguage"];
      this.env.DEFAULT_LanguageFamily=mdllanguagess["lanLanguageFamily"];
      this.env.DEFAULT_LanguageTag=mdllanguagess["lanLanguageTag"];
    }
  }
  */
  
  myBackButton(){
    this.location.back();
  }

  //https://gist.github.com/iamsainikhil/16b74485cf91ab0d691cc61734ffb569
  //https://stackoverflow.com/questions/17732897/difference-between-two-dates-in-years-months-days-in-javascript
  dateDifference(IsoDate:any, value: boolean) {
    // Converte IsoDate=T2021-06-03T08:54:49Z in Thu Jun 03 2021 10:54:49 GMT+0200 (Ora legale dell’Europa centrale)
    const date1:any = new Date(IsoDate); 
    const date2: any = new Date(); // Thu Jun 03 2021 15:02:24 GMT+0200 (Ora legale dell’Europa centrale)
    //console.log("IsoDate="+IsoDate+" date1="+date1+" date2="+date2);

    let r = {}; // object for clarity
    let message: string;

    const diffInSeconds: number = Math.abs(date2 - date1) / 1000;
    const days: number = Math.floor(diffInSeconds / 60 / 60 / 24);
    const hours: number = Math.floor(diffInSeconds / 60 / 60 % 24);
    const minutes: number = Math.floor(diffInSeconds / 60 % 60);
    const seconds: number = Math.floor(diffInSeconds % 60);
    const milliseconds: number = Math.round((diffInSeconds - Math.floor(diffInSeconds)) * 1000);
      const months: number = Math.floor(days / 31);
    const years: number = Math.floor(months / 12);
    //console.log("b) "+diffInSeconds+"-"+days+"-"+hours+"-"+minutes+"-"+seconds+"-"+milliseconds+"-"+months+years);

    // the below object is just optional 
    // if you want to return an object instead of a message
    r = {
        years,
        months,
        days,
        hours,
        minutes,
        seconds,
        milliseconds
    };

    // check if difference is in years or months
    if (years === 0 && months === 0) {
        // show in days if no years / months
        if (days > 0) {
            if (days === 1) {
                message = days + ' day';
            } else { message = days + ' days'; }
        }  else if (hours > 0) {
            // show in hours if no years / months / days
            if (hours === 1) {
                message = hours + ' hour';
            } else {
                message = hours + ' hours';
            }
        } else {
            // show in minutes if no years / months / days / hours
            if (minutes === 1) {
                message = minutes + ' minute';
            } else {message = minutes + ' minutes';}  
        }
    } else if (years === 0 && months > 0) {
        // show in months if no years
        if (months === 1) {
            message = months + ' month';
        } else {message = months + ' months';}
    } else if (years > 0) {
        // show in years if years exist
        if (years === 1) {
            message = years + ' year';
        } else {message = years + ' years';}
    }

    // To display either an object or a message in the view
    if (value === true) {
      return r;
    }
    //console.log("z) "+message)
    return message;
  }




}